<template>
  <div class="settings">
    <div class="page__header">
      <div class="page__title">{{ $t(`pageTitles.${"settings"}`) }}</div>
    </div>

    <div class="settings__settings">
      <div class="setting box box--default" :class="{ 'setting--general': showGeneralSetting }">
        <div class="label label--gradient">{{ $t(`settingsPage.${"general"}`) }}</div>

        <div class="setting__chevron" :class="{ 'setting__chevron--active': showGeneralSetting }"
          @click="showGeneralSetting = !showGeneralSetting"></div>

        <div class="setting__content">
          <div class="setting__section">
            <div class="setting__title">{{ $t(`settingsPage.${"theme"}`) }}</div>

            <div class="themes">
              <div class="theme" :class="{ 'theme-active': !isDarkMode }" @click="changeTheme(false)">
                <div class="theme__icon theme__icon--light"></div>
                <div class="theme__title">{{ $t(`settingsPage.${"lightMode"}`) }}</div>
              </div>
              <div class="theme" :class="{ 'theme-active': isDarkMode }" @click="changeTheme(true)">
                <div class="theme__icon theme__icon--dark"></div>
                <div class="theme__title">{{ $t(`settingsPage.${"darkMode"}`) }}</div>
              </div>
            </div>
          </div>

          <!-- <div class="setting__section" style="display: flex; align-items: center; gap: 15px;">
            <div class="setting__title" style="margin: 0;">Color Select</div>

 

            <div class="input-color-container">
            <input id="input-color" value="#ed6868" class="input-color" type="color">
          </div>
          </div> -->

          <div class="setting__section">
            <div class="setting__title">{{ $t(`settingsPage.${"language"}`) }}</div>

            <VSelect class="select select--default select--shadow" :options="languages" v-model="language" />
          </div>

          <div class="setting__section">
            <div class="setting__title">{{ $t(`settingsPage.${"notification"}`) }}</div>

            <div class="setting__options">
              <div class="setting__option">
                <div class="radio">
                  <input class="radio__radio" type="radio" name="notification" id="email" />
                  <label class="radio__label" for="email"></label>
                </div>
                <label for="email">Email</label>
              </div>

              <div class="setting__option">
                <div class="radio">
                  <input class="radio__radio" type="radio" name="notification" id="sms" />
                  <label for="sms" class="radio__label"></label>
                </div>
                <label for="sms">SMS</label>
              </div>

              <div class="setting__option">
                <div class="radio">
                  <input class="radio__radio" type="radio" name="notification" id="appSetting" />
                  <label for="appSetting" class="radio__label"></label>
                </div>
                <label for="appSetting">App</label>
              </div>
            </div>
          </div>

          <div class="setting__section">
            <div class="setting__title">{{ $t(`settingsPage.${"sort"}`) }}</div>

            <div class="setting__options">
              <div class="setting__option">
                <div class="radio">
                  <input class="radio__radio" type="radio" name="sort" id="firstNameLastName" />
                  <label for="firstNameLastName" class="radio__label"></label>
                </div>
                <label for="firstNameLastName">{{ $t(`settingsPage.${"sortByFirstName"}`) }}</label>
              </div>

              <div class="setting__option">
                <div class="radio">
                  <input class="radio__radio" type="radio" name="sort" id="lastNameFirstName" />
                  <label for="lastNameFirstName" class="radio__label"></label>
                </div>
                <label for="lastNameFirstName">{{ $t(`settingsPage.${"sortByLastName"}`) }}</label>
              </div>
            </div>
          </div>

          <div class="setting__buttons">
            <div v-if="isRequesting" class="button button--default button--loading"></div>
            <button v-else class="button button--default" @click="saveSettings">
              {{ $t(`buttons.${"saveBtn"}`) }}
            </button>
          </div>
        </div>
      </div>

      <div class="setting box box--default" :class="{ 'setting--user': showUserSetting }">
        <div class="label label--gradient">{{ $t(`settingsPage.${"user"}`) }}</div>

        <div class="setting__chevron" :class="{ 'setting__chevron--active': showUserSetting }"
          @click="showUserSetting = !showUserSetting"></div>

        <div class="setting__content">
          <div class="setting__section" v-if="instance.proxy.$checkRolePermission('sales_category_price_access')">
            <router-link :to="{ name: 'PriceCategories' }"
              class="input input--default input--shadow input--static input--edit">
              {{ $t(`settingsPage.${"priceCategory"}`) }}
            </router-link>
          </div>
          <div class="setting__section" v-if="instance.proxy.$checkRolePermission('sales_category_price_access')">
            <router-link :to="{ name: 'PriceCategoriesForSecondAgent' }"
              class="input input--default input--shadow input--static input--edit">
              {{ $t(`settingsPage.${"priceCategoryForSecondAgent"}`) }}
            </router-link>
          </div>
          <div class="setting__section" v-if="instance.proxy.$checkRolePermission('role_access')">
            <router-link :to="{ name: 'UserRights' }"
              class="input input--default input--shadow input--static input--edit">
              {{ $t(`settingsPage.${"userRights"}`) }}
            </router-link>
          </div>
          <div class="setting__section" v-if="instance.proxy.$checkRolePermission('provision_import_preview')">
            <a href="#" class="input input--default input--shadow input--static input--upload"
              @click.prevent="store.commit('setShowPolicyProvisionImportModal', true);">
              {{ $t(`settingsPage.${"provisionImport"}`) }}
            </a>
          </div>
        </div>
      </div>
 
      <div class="setting box box--default" :class="{ 'setting--system': showSystemSetting }" v-if="loggedUser.is_super_admin">
        <div class="label label--gradient">{{ $t(`settingsPage.${"system"}`) }}</div>

        <div class="setting__chevron" :class="{ 'setting__chevron--active': showSystemSetting }"
          @click="showSystemSetting = !showSystemSetting"></div>

        <div class="setting__content">
          <div class="setting__section">
            <router-link :to="{ name: 'Teams' }" class="input input--default input--shadow input--static input--edit">
             {{ $t(`settingsPage.${"teams"}`) }}
            </router-link>
          </div>

          <div class="setting__section">
            <div class="input input--default input--shadow input--static input--characters">
              {{ $t(`settingsPage.${"textSettings"}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();
const instance = getCurrentInstance();

// Reactive data
const showGeneralSetting = ref(false);
const showUserSetting = ref(false);
const showSystemSetting = ref(false);
const languages = ref(
  (process.env.VUE_APP_I18N_SUPPORTED_LOCALE || "")
    .split(",")
    .map((locale) => locale.trim())
    .filter((locale) => locale)
);
const isRequesting = ref(false);

// Computed properties
const language = computed({
  get: () => store.getters.language,
  set: (value) => store.commit("setLanguage", value),
});
const isDarkMode = computed(() => store.getters.isDarkMode);
const loggedUser = computed(() => store.getters.loggedUser);

// Methods
const changeTheme = (mode) => {
  store.commit("setIsDarkMode", mode);

  window.localStorage.setItem("darkMode", mode);

  document.documentElement.setAttribute("data-theme", mode ? "dark" : "light");
};

const saveSettings = async () => {
  try {
    isRequesting.value = true;
    const storedUser = JSON.parse(window.localStorage.getItem("user"));
    const userId = storedUser.id;
    
    await store.dispatch("saveSettings", {
      userId,
      locale: language.value,
    });
    
    // Extract locale code from language value
    const rawLang = language.value;
    const localeCode = typeof rawLang === 'string'
      ? rawLang
      : (rawLang && (rawLang.code || rawLang.language))
        ? (rawLang.code || rawLang.language)
        : process.env.VUE_APP_I18N_LOCALE || 'de';

    // Update local state
    if (instance.proxy.$i18n.locale !== localeCode) {
      window.localStorage.setItem("language", localeCode);
      instance.proxy.$i18n.locale = localeCode;
      store.commit("setLanguage", localeCode);
    }
    
    // Update the stored user object to persist language preference
    if (!storedUser.settings) {
      storedUser.settings = {};
    }
    storedUser.settings.locale = localeCode;
    window.localStorage.setItem("user", JSON.stringify(storedUser));
    
    store.commit("setToast", {
      display: true,
      type: "success",
      message: instance.proxy.$t("messages.settingsSavedSuccessfully"),
    });
    
    isRequesting.value = false;
  } catch (err) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: instance.proxy.$t("messages.errorSavingSettings"),
    });
    console.error("Error saving settings:", err);
    isRequesting.value = false;
  }
};

// Lifecycle
onMounted(() => {
  if (!instance.proxy.$checkRolePermission('settings_access')) {
    router.push('/dashboard');
  }
});
</script>

<style scoped lang="scss">
[data-theme=dark] .select--default {
  box-shadow: none;
  border: 1px solid #46505B;
}

.input-color-container {
  position: relative;
  overflow: hidden;
  width: 25px;
  height: 25px;
  border: solid 2px #ddd;
  border-radius: 40px;
  cursor: pointer;
}

.input-color {
  position: absolute;
  right: -8px;
  top: -8px;
  width: 56px;
  height: 56px;
  border: none;
  cursor: pointer;
}

.settings .setting .themes .theme:hover .theme__title[data-v-b66ee972] {
  color: var(--text-5);
}

.settings {
  &__settings {
    margin-top: 40px;
    display: flex;
    align-items: flex-start;
  }

  .setting {
    width: 400px;
    background: var(--bg-1);
    margin-right: 40px;
    position: relative;

    &__content {
      max-height: 0px;
      opacity: 0;
      overflow: hidden;
      padding: 55px 20px 35px 20px;
      transition: all 0.3s ease;
    }

    &--general {
      .setting__content {
        max-height: 577px;
      }
    }

    &--user,
    &--system {
      .setting__content {
        max-height: 355px;
      }
    }

    &--general,
    &--user,
    &--system {
      .setting__content {
        opacity: 1;
      }
    }

    &__chevron {
      position: absolute;
      z-index: 2;
      right: 20px;
      top: 20px;
      width: 30px;
      height: 30px;
      background: url("../assets/icons/default/Bold 2px-chevron_down.svg") no-repeat center;
      background-size: 100%;
      cursor: pointer;
      transition: all 0.3s ease;

      &--active {
        transform: rotateX(180deg);
      }
    }

    &__section {
      padding: 15px 0;
      border-bottom: 1px solid var(--border-15);
    }

    &__title {
      color: var(--text-2);
      font-size: var(--x-small);
      font-family: var(--muli-text-semi-bold);
      margin-bottom: 20px;
    }

    .themes {
      display: flex;

      .theme {
        cursor: pointer;

        &:first-child {
          padding-right: 15px;
          border-right: 1px solid var(--border-6);
        }

        &:nth-child(2) {
          padding-left: 15px;
        }

        &__icon {
          height: 24px;
          width: 24px;
          margin: 5px auto;

          &--light {
            background: url("../assets/icons/default/lightmode_icon.svg");
          }

          &--dark {
            background: url("../assets/icons/default/darkmode_icon.svg");
          }
        }

        &__title,
        &__icon {
          transition: all 0.3s ease;
        }

        &__title {
          font-size: var(--x-smaller);
          color: var(--text-2);
          ;
        }

        &:hover {
          .theme__title {
            color: var(--text-5);
          }

          .theme__icon--dark {
            background: url("../assets/icons/default/darkmode_hover_icon.svg");
          }

          .theme__icon--light {
            background: url("../assets/icons/default/lightmode_hover_icon.svg");
          }
        }
      }

      .theme-active {
        .theme__title {
          color: var(--text-5);
        }

        .theme__icon--dark {
          background: url("../assets/icons/default/darkmode_hover_icon.svg");
        }

        .theme__icon--light {
          background: url("../assets/icons/default/lightmode_hover_icon.svg");
        }

      }
    }

    .input {
      &--static {
        display: flex;
        align-items: center;
      }

      &--edit,
      &--characters,
      &--upload {
        background-repeat: no-repeat;
        background-position: calc(100% - 10px) center;
      }

      &--edit {
        background-image: url("../assets/icons/default/edit_icon.svg");
      }

      &--upload {
        background-image: url("../assets/icons/default/upload_icon.svg");
      }

      &--characters {
        background-image: url("../assets/icons/default/text_settings_icon.svg");
      }
    }

    &__buttons {
      margin-top: 40px;

      .button {
        width: 135px;
      }
    }

    &__options {
      display: flex;
    }

    &__option {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .radio {
        margin-right: 5px;
      }

      label {
        font-size: var(--x-small);
        color: var(--text-2);
      }
    }
  }
}
</style>
